var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarCheck2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 36,
    viewBox: "0 0 34 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7128 10L15.8564 2L2 10V26L15.8564 34M29.7128 10L15.8564 19M29.7128 10V18M15.8564 34V19M15.8564 34L18.8555 32.2685M15.8564 19L2.85641 11M21.8564 14L8.85641 6M23.8564 28L25.8564 30L31.8564 24",
    stroke: "#FF6A46",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCheck2);
export default __webpack_public_path__ + "static/media/barCheck2.658f6893a01106c923d33dc7c9a872d7.svg";
export { ForwardRef as ReactComponent };